<template>
  <v-dialog
    width="45vw"
    v-model="dialog"
    ref="dialog"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="dialog">
        <v-card-title>
          <v-toolbar
            elevation="0"
            style="background-color: transparent"
            class="d-flex align-center justify-center"
          >
            <v-row align="center" justify="center" dense
              ><span class="text-h4" style="color: #a826e1">{{
                form.id ? $t("planForm.edit") : $t("planForm.create")
              }}</span>
            </v-row>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.format"
                :label="$t('planForm.modality')"
                :items="formats"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.frequency"
                :label="$t('planForm.frequency')"
                :items="frequencies"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="value"
                :label="$t('planForm.value')"
                placeholder="R$"
                :value="value"
                :rules="rules.value"
                :hint="
                  $t('planForm.valueHint', { value: displayValue ?? 'R$' })
                "
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="discount"
                :label="$t('planForm.discount')"
                placeholder="R$"
                :value="discount"
                :hint="
                  $t('planForm.discountHint', {
                    value: displayDiscount ?? 'R$',
                  })
                "
                :rules="rules.discount"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined color="warning-500" @click="closeDialog">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn
            rounded
            outnlined
            color="secondary-500"
            class="white--text"
            @click="save"
          >
            {{ form.id ? $t("common.save") : $t("planForm.createBtn") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { formatBRL } from "@/plugins/i18n";
import { GROUP_FORMAT_OPTIONS } from "@/shared/classPresentation";

// Plano usa o enum PerWeekPlans da API (5 = quinzenal), diferente do da turma.
const PLAN_FREQUENCIES = [1, 2, 3, 4, 5];

export default {
  name: "PlanDialog",
  mixins: [],
  props: {
    platformFee: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      formats: GROUP_FORMAT_OPTIONS,
      value: null,
      discount: null,
      displayValue: null,
      displayDiscount: null,
      form: {
        format: null,
        frequency: null,
      },
      rules: {
        value: [
          (v) => (Number(v) || 0) > 0 || this.$t("planForm.valuePositive"),
        ],
        discount: [
          (v) => (Number(v) || 0) >= 0 || this.$t("planForm.discountNegative"),
          (v) => this.checkPrice(v) || this.$t("planForm.discountTooHigh"),
          (v) =>
            this.checkFinalValue(v) ||
            this.$t("planForm.belowFee", { fee: this.displayFee }),
        ],
      },
    };
  },
  computed: {
    displayFee() {
      return formatBRL(this.platformFee);
    },
    frequencies() {
      return PLAN_FREQUENCIES.map((value) => ({
        text: this.$t(`planForm.freq.${value}`),
        value,
      }));
    },
  },
  watch: {
    value(price) {
      if (price) {
        this.displayValue = formatBRL(price);
      }
    },
    discount(value) {
      if (value) {
        this.displayDiscount = formatBRL(value);
      }
    },
  },
  mounted() {},
  methods: {
    checkPrice(value) {
      return (Number(value) || 0) <= (Number(this.value) || 0) ? true : false;
    },
    checkFinalValue(value) {
      const finalValue = (Number(this.value) || 0) - (Number(value) || 0);
      return finalValue >= (Number(this.platformFee) || 0);
    },
    openDialog(plan) {
      if (plan) {
        this.form = {
          id: plan.id,
          format: plan.format,
          frequency: plan.frequency,
        };
        this.value = plan.value;
        this.discount = plan.discount;
      }
      this.dialog = true;
    },
    closeDialog() {
      this.value = null;
      this.discount = null;
      this.displayValue = null;
      this.displayDiscount = null;
      this.form = {
        format: null,
        frequency: null,
      };
      this.dialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("savePlan", {
          ...this.form,
          value: Number(this.value),
          discount: Number(this.discount || 0),
        });
      }
    },
  },
};
</script>
<style scoped>
.dialog {
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 32px 0 rgba(70, 81, 228, 0.37);
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>
